module.exports = __webpack_public_path__ + "img/launcher.5b0ee833.svg";